export enum TR_SECTION_TITLES {
  SKIN_ANALYSIS = 'Skin Analysis',
  CLEANSE_AND_COMMUNICATE = 'Cleanse & Communicate',
  CORE_SEGMENT = 'Core Segments',
  REHYDRATE_AND_RECAP = 'Rehydrate & Recap',
  TREATMENT_WRAP_UP = 'Treatment Wrap Up',
  CLIENT_FOLLOW_UP = 'Client Follow-Up',
}

export enum CORE_SEGMENT_INNER_SECTION_TITLES {
  EXFOLIATION_SEGMENT = 'Exfoliation Segment',
  EXTRACTIONS_SEGMENT = 'Extractions Segment',
  TOUCH_POINT_SEGMENT = 'Touch Point Segment',
  MASK_SEGMENT = 'Mask Segment',
  TARGETED_THERAPY_SEGMENT = 'Targeted Therapy Segment',
  SOS_TREATMENT = 'SOS Treatment',
}

export enum AXIOS_METHODS {
  GET = 'GET',
  POST = 'POST',
  PATCH = 'PATCH',
  PUT = 'PUT',
  DELETE = 'DELETE',
}

export enum ELEMENT_ID {
  MANAGE_CLIENT_PREFERENCES = 'manage_client_preferences',
}

export enum TREATMENT_SECTIONS {
  CONDITIONS = 'Conditions',
  CORE_SEGMENTS = 'Core Segments',
  ENHANCEMENTS = 'Enhancements',
  TREATMENT_NOTE = 'Treatment Note',
}

export enum PAST_TR_SECTIONS {
  CLIENT_FOLLOW_UP = 'Client Follow-Up',
}

export enum CLIENT_LOOK_UP {
  PHONE_NUMBER_MISSING = 'Missing Phone Number',
  EMAIL_MISSING = 'Missing Email',
}
